import VivialConnectAdminAPI from "api/vivial-connect-admin";
const { contacts } = VivialConnectAdminAPI.services;

export const emailList = async (params) => {
  const { emails } = await contacts.getContactEmails(params);
  return emails;
};
